import React from 'react';
import { Box } from '@mui/material';
import DashboardLayout from '../layouts/DashboardLayout';
import SupportResourcesPanel from '../shared/SupportResourcesPanel';

const AdminSupportResources = () => (
  <DashboardLayout title="Support Resources">
    <Box sx={{ maxWidth: 960, mx: 'auto' }}>
      <SupportResourcesPanel allowUpload userRole="admin" />
    </Box>
  </DashboardLayout>
);

export default AdminSupportResources;
